export default __webpack_public_path__ + "static/media/checkbox_white_full.6211ff39.svg";